(function () {
    const DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');

    function init(section) {
        if (!section || section.dataset.contentCardsSliderInitialized === 'true') return;

        const sliderElement = section.querySelector('[data-content-cards-slider-element]');
        const prevButton = section.querySelector('[data-content-cards-slider-prev]');
        const nextButton = section.querySelector('[data-content-cards-slider-next]');

        if (!sliderElement || typeof Splide === 'undefined') return;

        section.dataset.contentCardsSliderInitialized = 'true';

        const slideCount = sliderElement.querySelectorAll('.splide__slide').length;
        const slider = new Splide(sliderElement, {
            type: slideCount > 3 ? 'loop' : 'slide',
            clones: slideCount > 3 ? Math.max(slideCount, 3) : 0,
            perPage: 3,
            perMove: 1,
            gap: 0,
            arrows: false,
            pagination: false,
            drag: true,
            snap: true,
            speed: 700,
            trimSpace: false,
            focus: 0,
            breakpoints: {
                989: {
                    type: slideCount > 1 ? 'loop' : 'slide',
                    clones: slideCount > 1 ? Math.max(slideCount, 3) : 0,
                    perPage: 1,
                    fixedWidth: '50vw',
                    focus: 0,
                    padding: {
                        left: '0',
                        right: '0'
                    }
                },
                749: {
                    fixedWidth: '50vw',
                    padding: {
                        left: '0',
                        right: '0'
                    }
                },
                599: {
                    fixedWidth: '92vw',
                    padding: {
                        left: '0',
                        right: '0'
                    }
                }
            }
        });

        section.contentCardsSlider = slider;

        if (prevButton) {
            prevButton.addEventListener('click', () => {
                slider.go('<');
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => {
                slider.go('>');
            });
        }

        slider.on('mounted moved updated resized', () => {
            updateArrows(slider, prevButton, nextButton);
        });

        slider.mount();

        initDragCursor(section, sliderElement);
        updateArrows(slider, prevButton, nextButton);
    }

    function destroy(section) {
        if (!section) return;

        if (section.contentCardsSlider) {
            section.contentCardsSlider.destroy(true);
            section.contentCardsSlider = null;
        }

        section.dataset.contentCardsSliderInitialized = 'false';

        const cursor = section.querySelector('.content-cards-slider__drag-cursor');

        if (cursor) {
            cursor.remove();
        }
    }

    function updateArrows(slider, prevButton, nextButton) {
        if (!slider || !prevButton || !nextButton) return;

        const isLoop = slider.options.type === 'loop';

        if (isLoop) {
            prevButton.disabled = false;
            nextButton.disabled = false;
            return;
        }

        const end = slider.Components.Controller.getEnd();

        prevButton.disabled = slider.index <= 0;
        nextButton.disabled = slider.index >= end;
    }

    function initDragCursor(section, sliderElement) {
        if (!section || !sliderElement) return;

        let cursor = section.querySelector('.content-cards-slider__drag-cursor');

        if (!cursor) {
            cursor = document.createElement('div');
            cursor.className = 'content-cards-slider__drag-cursor';
            cursor.textContent = 'Drag';
            sliderElement.appendChild(cursor);
        }

        const moveCursor = (event) => {
            if (!DESKTOP_QUERY.matches) {
                cursor.classList.remove('is-visible', 'is-dragging');
                return;
            }

            const isArrow = event.target.closest('.content-cards-slider__arrow');

            if (isArrow) {
                cursor.classList.remove('is-visible');
                return;
            }

            const rect = sliderElement.getBoundingClientRect();

            cursor.style.setProperty('--cursor-x', `${event.clientX - rect.left}px`);
            cursor.style.setProperty('--cursor-y', `${event.clientY - rect.top}px`);
            cursor.classList.add('is-visible');
        };

        sliderElement.addEventListener('mousemove', moveCursor);

        sliderElement.addEventListener('mouseenter', (event) => {
            moveCursor(event);
        });

        sliderElement.addEventListener('mouseleave', () => {
            cursor.classList.remove('is-visible', 'is-dragging');
        });

        sliderElement.addEventListener('mousedown', () => {
            if (!DESKTOP_QUERY.matches) return;

            cursor.classList.add('is-dragging');
        });

        window.addEventListener('mouseup', () => {
            cursor.classList.remove('is-dragging');
        });

        sliderElement.addEventListener('touchstart', () => {
            cursor.classList.remove('is-visible', 'is-dragging');
        });
    }

    window.NorkayaContentCardsSlider = {
        init,
        destroy
    };
})();
